module.exports = "/_next/static/images/AggregationProfileAPI-a443f02984dfe21e30aa9947b43d4943.webp";